import React from "react";
import RenderHtml from "react-native-render-html";

const defaultText = "<p>--</p>";

function HtmlText({ text = defaultText }) {
  const htmlTagStyles = {
    p: {
      textAlign: "center",
      color: "rgba(0, 0, 0, 0.56)",
      fontSize: 12,
    },
    span: {
      color: "#00AB59",
      fontWeight: "bold",
    },
  };
  return <RenderHtml html={`<p>${text}</p>`} tagsStyles={htmlTagStyles} />;
}

export default HtmlText;
